import { frontendConfig } from './shared/config/env';

const appName = 'LiveNet';

export interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed'; platform: string }>;
}

export async function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) {
    return null;
  }

  if (frontendConfig.isProduction && 'serviceWorker' in navigator) {
    navigator.serviceWorker.register('/sw.js');
  }
}

export function getInitialNotificationPermission() {
  if (!('Notification' in window)) {
    return 'unsupported' as const;
  }

  return Notification.permission;
}

export async function requestNotificationPermission() {
  if (!('Notification' in window)) {
    return 'unsupported' as const;
  }

  return Notification.requestPermission();
}

export async function showTestNotification() {
  if (!('Notification' in window) || Notification.permission !== 'granted') {
    return false;
  }

  const registration = await navigator.serviceWorker.getRegistration();
  if (registration) {
    await registration.showNotification(appName, {
      body: 'Уведомления работают. Приложение готово к PWA-сценариям.',
      icon: '/icons/icon-192.svg',
      badge: '/icons/icon-192.svg',
      tag: 'pwa-test',
    });
    return true;
  }

  new Notification(appName, {
    body: 'Уведомления работают. Приложение готово к PWA-сценариям.',
    icon: '/icons/icon-192.svg',
  });
  return true;
}
